import { render, staticRenderFns } from "./chooseCoupon.vue?vue&type=template&id=cb97806a&scoped=true"
import script from "./chooseCoupon.vue?vue&type=script&lang=ts"
export * from "./chooseCoupon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb97806a",
  null
  
)

export default component.exports